<template>
  <div class="w-100 flex-grow-1 d-flex flex-column">
    <!-- Search bar -->
    <div class="d-flex px-4 py-3">
      <SwiftDatePicker v-model="dateRange" placeholder="Select Date Range" />
    </div>
    <!-- Table -->
    <div class="card shadow-sm w-100 flex-grow-1">
      <div
        v-if="loading"
        class="d-flex justify-content-center align-items-center p-5"
      >
        <div class="spinner-border text-success" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div v-else class="table-responsive w-100">
        <table class="table align-middle mb-0 w-100">
          <thead class="table-light">
            <tr>
              <th>Activity</th>
              <th>Timestamp</th>
              <th>IP Address</th>
              <th>Device/Browser</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(userLog, index) in filteredUserLogs" :key="index">
              <td>{{ userLog.description }}</td>
              <td>{{ userLog.created_at }}</td>
              <td>{{ userLog.ip_address }}</td>
              <td>{{ userLog.user_agent }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div
        class="d-flex justify-content-between align-items-center border-top p-2 w-100"
      >
        <div class="d-flex align-items-center gap-2">
          Show
          <select class="form-select d-inline" v-model="pageSize">
            <option>5</option>
            <option>10</option>
            <option>20</option>
          </select>
          <div>of {{ pagination.total }} Items</div>
        </div>
        <nav>
          <ul class="pagination mb-0">
            <li
              :class="[
                'page-item',
                { disabled: pagination.current_page === 1 },
              ]"
            >
              <button
                class="page-link"
                @click="goToPage(pagination.current_page - 1)"
              >
                &lt;
              </button>
            </li>

            <li
              v-for="page in pagination.last_page"
              :key="page"
              :class="[
                'page-item',
                { active: pagination.current_page === page },
              ]"
            >
              <button class="page-link" @click="goToPage(page)">
                {{ page }}
              </button>
            </li>

            <li
              :class="[
                'page-item',
                { disabled: pagination.current_page === pagination.last_page },
              ]"
            >
              <button
                class="page-link"
                @click="goToPage(pagination.current_page + 1)"
              >
                &gt;
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserManagementLogActivities } from "@/api/user-management";
import SwiftDatePicker from "@/components/SwiftDatePicker.vue";
import { useRoute } from "vue-router";

export default {
  name: "UserManagementView",
  components: { SwiftDatePicker },
  data() {
    return {
      pageSize: 5,
      openMenuIndex: null,
      userLogActivities: [],
      loading: false,
      pagination: {
        current_page: 1,
        per_page: 5,
        total: 0,
        last_page: 1,
      },
    };
  },
  computed: {
    filteredUserLogs() {
      return this.userLogActivities;
    },
  },
  methods: {
    async fetchUserManagementLogActivityData(
      page = 1,
      perPage = this.pageSize
    ) {
      this.loading = true;
      try {
        const params = {
          page,
          per_page: perPage,
        };

        const route = useRoute();
        const merchantUserId = route.params.id;

        const response = await getUserManagementLogActivities(
          merchantUserId,
          params
        );

        if (response && response.status === "success" && response.data) {
          this.userLogActivities = response.data.data || response.data || [];
          // Laravel pagination format
          this.pagination.current_page = response.data.current_page;
          this.pagination.per_page = response.data.per_page;
          this.pagination.total = response.data.total;
          this.pagination.last_page = response.data.last_page;
        } else {
          this.userLogActivities = [];
        }
      } catch (error) {
        this.userLogActivities = [];
        this.$swal("Failed to fetch user logs data");
      } finally {
        this.loading = false;
      }
    },

    async goToPage(page) {
      if (page < 1 || page > this.pagination.last_page) return;
      await this.fetchUserManagementData(page, this.pageSize, this.search);
    },
  },
  watch: {
    pageSize(newVal) {
      this.fetchUserManagementLogActivityData(1, newVal, this.search);
    },
  },
  mounted() {
    this.fetchUserManagementLogActivityData();
    document.addEventListener("click", this.closeAnyMenu);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeAnyMenu);
  },
};
</script>
